import DocumentsReviewFormPanel from "./DocumentsReviewFormPanel";

export default DocumentsReviewFormPanel;
